/**
 * 无 product-sticky-bar 时的左栏吸顶 top 兜底（仅 header）。
 * 有 tabbar 时由 product-sticky-bar.liquid 统一写入 --main-product-sticky-top。
 */
(function () {
  "use strict";

  var MOBILE_MAX = 768;
  var GAP_PX = 16;

  function isDesktop() {
    return window.matchMedia("(min-width: " + (MOBILE_MAX + 1) + "px)").matches;
  }

  function hasTabbarCoordinator() {
    return !!document.querySelector(".product-sticky-bar.enable_sticky");
  }

  function getHeaderSection() {
    return (
      document.querySelector(".bh-header-section") ||
      document.getElementById("shopify-section-header")
    );
  }

  function measureStickyTop() {
    var offset = GAP_PX;
    var header = getHeaderSection();

    if (header && !header.classList.contains("z-index-1")) {
      var rect = header.getBoundingClientRect();
      if (rect.height > 0 && rect.bottom > 0) {
        offset = Math.max(offset, rect.bottom + GAP_PX);
      }
    }

    return offset;
  }

  function apply() {
    if (!isDesktop() || hasTabbarCoordinator()) {
      if (!hasTabbarCoordinator()) {
        document.documentElement.style.removeProperty("--main-product-sticky-top");
      }
      return;
    }

    document.documentElement.style.setProperty(
      "--main-product-sticky-top",
      measureStickyTop() + "px"
    );
  }

  var rafId = null;

  function schedule() {
    if (rafId != null) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      apply();
    });
  }

  if (document.querySelector(".main-product__media-sticky")) {
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    window.addEventListener("load", schedule);
    schedule();
  }
})();
